import React, { useCallback } from "react";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import AppContent from "./AppContent";
import { UserManagerProvider, useUserManager } from "@/contexts/UserManagerProvider";

const AppWithAuth: React.FC = () => {
  const userManager = useUserManager();

  // Clean the URL after login, as required by react-oidc-context and
  // documented for this library
  const onSigninCallback = useCallback(() => {
    window.history.replaceState({}, "unused", window.location.pathname);
  }, []);

  return (
    <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
      <AppContent />
    </AuthProvider>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <UserManagerProvider>
        <AppWithAuth />
      </UserManagerProvider>
      <Toaster />
    </BrowserRouter>
  );
};

export default App;
